/**
 * @description Scrolls animated to the specified offset.
 * @param {Number} to
 * @param {Number} duration
 */
export const animateScroll = (to = 0, duration = 400) => {
  let scrollTop = Math.max(
    window.pageYOffset,
    document.body.scrollTop,
    document.documentElement.scrollTop
  );
  const difference = to - scrollTop;
  const perTick = (difference / duration) * 10;

  requestAnimationFrame(() => {
    scrollTop += perTick;
    document.body.scrollTop = scrollTop;
    document.documentElement.scrollTop = scrollTop;

    if (scrollTop === to) return;

    animateScroll(to, duration - 5);
  });
};

export default animateScroll;
